import { render, staticRenderFns } from "./MessageTypeSelection.vue?vue&type=template&id=7eaa1112&"
import script from "./MessageTypeSelection.vue?vue&type=script&lang=js&"
export * from "./MessageTypeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports